import * as React from 'react';
import clx from 'classnames';
import './RequestTableCellActions.scss';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { EditOutlined, EyeOutlined } from '@ant-design/icons';
import { IRequest, RequestState } from 'common/schema/request/Request';
import { useTranslation } from 'react-i18next';

export interface RequestTableCellActionsProps {
  request: IRequest;
  mobileOnly?: boolean;
}

export function RequestTableCellActions(props: RequestTableCellActionsProps) {
  const { request } = props;
  const { t } = useTranslation();

  return (
    <span
      className={clx('request-table-cell-actions', {
        'mobile-only': props.mobileOnly
      })}
    >
      {request.state === RequestState.Sent ||
      request.state === RequestState.Tested ? (
        <Link to={`/richieste/${request.id}/dettaglio`}>
          <Button type="primary" icon={<EyeOutlined />}>
            {t('procedures.my.list.actions.see-detail', 'Dettaglio')}
          </Button>
        </Link>
      ) : request.state === RequestState.NeedRetry ||
        request.state === RequestState.Sending ? (
        <Link to={`/richieste/${request.id}/modulo`}>
          <Button icon={<EyeOutlined />}>
            {t('procedures.my.list.actions.see-detail', 'Dettaglio')}
          </Button>
        </Link>
      ) : request.state === RequestState.Cancelled ? (
        <></>
      ) : (
        <Link to={`/richieste/${request.id}/modulo`}>
          <Button icon={<EditOutlined />}>
            {t('procedures.my.list.actions.see-fill-in', 'Compila')}
          </Button>
        </Link>
      )}
    </span>
  );
}
